module.exports = __webpack_public_path__ + "img/NO.d1bb2f4e.png";